// Referrals API for DIOS10
import apiClient from './client';
import { API_ENDPOINTS } from './config';

export const referralsApi = {
    // Get date range of available referral earnings (for period filters)
    getEarningsRange: async () => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.REFERRALS.EARNINGS_RANGE);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get top referrers (public leaderboard)
    // period: 'monthly' | 'semestral' | 'annual', year, month (0-11)
    getTopReferrers: async (limit = 10, period, year, month) => {
        try {
            const params = { limit };
            if (period) params.period = period;
            if (year !== undefined && year !== null) params.year = year;
            if (month !== undefined && month !== null) params.month = month;
            const response = await apiClient.get(API_ENDPOINTS.REFERRALS.TOP_REFERRERS, {
                params
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get referral network
    getNetwork: async (userId) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.REFERRALS.NETWORK(userId));
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get referral earnings
    getEarnings: async (userId, limit = 50) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.REFERRALS.EARNINGS(userId), {
                params: { limit }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Calculate buy-in referral earnings
    calculateBuyIn: async (amount) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.REFERRALS.CALCULATE_BUYIN, {
                params: { amount }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Calculate marketplace fee referral earnings
    calculateMarketplaceFee: async (amount) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.REFERRALS.CALCULATE_MARKETPLACE_FEE, {
                params: { amount }
            });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

export default referralsApi;
